const ProcessSection = () => {
  const steps = [
    {
      number: '1',
      title: 'Contacto y Presupuesto',
      description: 'Llámanos o escríbenos y te daremos un presupuesto sin compromiso en menos de 24 horas',
    },
    {
      number: '2',
      title: 'Visita Gratuita',
      description: 'Visitamos el espacio para evaluar el trabajo y ajustar el presupuesto si es necesario',
    },
    {
      number: '3',
      title: 'Ejecución Profesional',
      description: 'Nuestro equipo realiza el vaciado y limpieza con máxima eficiencia y discreción',
    },
    {
      number: '4',
      title: 'Entrega Impecable',
      description: 'Dejamos el espacio completamente limpio y listo para su nuevo uso',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">Cómo trabajamos</h2>
          <div className="w-16 h-1 bg-primary mx-auto"></div>
          <p className="mt-6 text-lg text-gray-700 max-w-3xl mx-auto">
            Nuestro proceso está diseñado para ofrecerte la máxima tranquilidad y resultados excepcionales en cada vaciado de piso o local en Mollet del Vallès y comarca.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-primary transform -translate-y-1/2"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 relative">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.2}s both`,
                }}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 rounded-full border-4 border-primary bg-white flex items-center justify-center mb-6 relative z-10">
                    <span className="text-3xl font-bold text-primary">{step.number}</span>
                  </div>

                  <h3 className="text-xl font-semibold text-dark mb-3">{step.title}</h3>

                  <p className="text-gray-600 text-sm leading-relaxed max-w-xs">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            ¿Necesitas un vaciado urgente? Ofrecemos servicio de urgencia 24 horas en Mollet del Vallès, La Llagosta, Montornès del Vallès y toda la zona del Vallès Oriental.
          </p>
          <a
            href="tel:+34602365996"
            className="inline-flex items-center space-x-2 bg-dark text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl"></i>
            <span>Llamar para Servicio Urgente</span>
          </a>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default ProcessSection;